<div class="font-bold mb-3" i18n>You have selected "TUAK" authentication algorithm.</div>
<div class="font-bold mb-3" i18n>Please select the following algorithm options according to your AuC configuration.</div>
<div class="ml-6 pt-3">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>RES size</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.resSize"
          inputId="networkAuthentication.tuakOptions.resSize#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.resSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.resSize#1" i18n>32 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.resSize"
          inputId="networkAuthentication.tuakOptions.resSize#2"
          value="2"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.resSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.resSize#2" i18n>64 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.resSize"
          inputId="networkAuthentication.tuakOptions.resSize#3"
          value="3"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.resSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.resSize#3" i18n>128 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.resSize"
          inputId="networkAuthentication.tuakOptions.resSize#4"
          value="4"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.resSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.resSize#4" i18n>256 bits</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>MAC-A and MAC-S size</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.macSize"
          inputId="networkAuthentication.tuakOptions.macSize#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.macSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.macSize#1" i18n>64 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.macSize"
          inputId="networkAuthentication.tuakOptions.macSize#2"
          value="2"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.macSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.macSize#2" i18n>128 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.macSize"
          inputId="networkAuthentication.tuakOptions.macSize#3"
          value="3"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.macSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.macSize#3" i18n>256 bits</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>CK and IK size</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.ckikSize"
          inputId="networkAuthentication.tuakOptions.ckikSize#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.ckikSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.ckikSize#1" i18n>128 bits</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.ckikSize"
          inputId="networkAuthentication.tuakOptions.ckikSize#2"
          value="2"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.ckikSize"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.ckikSize#2" i18n>256 bits</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>Key Length</span>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.keyLength"
          inputId="networkAuthentication.tuakOptions.keyLength#1"
          value="1"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.keyLength"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.keyLength#1" i18n>16 bytes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="networkAuthentication.tuakOptions.keyLength"
          inputId="networkAuthentication.tuakOptions.keyLength#2"
          value="2"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.keyLength"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="networkAuthentication.tuakOptions.keyLength#2" i18n>32 bytes</label>
      </td>
    </tr>
    <tr>
      <td>
        <span class="mr-6 font-bold" i18n>Number Of Keccak</span>
      </td>
      <td colspan="8">
        <p-inputNumber
          inputStyleClass="console-text"
          [(ngModel)]="profileValues.networkAuthentication.tuakOptions.numberOfKeccak"
          [min]="1"
          [max]="1600"
          [maxlength]="4"
          [useGrouping]="false"
          (onBlur)="handleFormEvents()"
        ></p-inputNumber>
      </td>
    </tr>
  </table>
</div>
